import { trocarModo } from '../lib/modo.js';
import { Botao, EstadoVazio } from './ui/index.js';

/** Tela de cadastro aberta com dados ficticios (so leitura) ou por quem nao e da equipe. */
export function SemCadastro({ demo }: { demo: boolean }) {
  return demo ? (
    <EstadoVazio
      titulo="Cadastro indisponível com dados fictícios"
      acao={
        <Botao variante="principal" onClick={() => trocarModo('real')}>
          Desligar os dados fictícios
        </Botao>
      }
    >
      Os dados fictícios são só para leitura. Desligue-os para cadastrar os dados reais deste aparelho.
    </EstadoVazio>
  ) : (
    <EstadoVazio titulo="Sem permissão para cadastrar">
      Cadastro de haras, animais e visitas é feito pela equipe Equiview.
    </EstadoVazio>
  );
}
